import React, { useState, useEffect } from "react";
import { Form, Button, Row, Col, Toast } from "react-bootstrap";
import { connect } from "react-redux";
import validate from "../../_services/formValidation";
import { _HttpServices } from "../../_services/_HttpServices";
import { IoIosClose, IoMdDoneAll } from "react-icons/io";
import Loader from "../../components/Loader";
import { useHistory } from "react-router-dom";
import moment from 'moment'
import { Footer } from "../../components/Footer";
const intialValues = {
  FirstName: "",
  LastName: "",
  UserName: "",
  EmailID: "",
  ContactNumber: "",
  Street: "",
  RoleID: "",
  City: "",
  Status: true,
  ZIPCode: "",
  CreatedBy: "",
  ModifiedBy: "",
  Modifieddate: "",
  Id: "",
};
// let btnText = "Submit";

const AddUser = ({ dispatch, login }) => {
  const history = useHistory();
  const loggedInUserData = JSON.parse(localStorage.getItem("userData"));
  const [values, setValues] = useState(intialValues);
  const [errors, setErrors] = useState({});
  const [roles, setRoles] = useState([]);
  const [userUpdated, setUserUpdated] = useState(false);
  const [isDataChange, setIsDataChange] = useState(false);
  const [userNameErr, setUserNameErr] = useState(false);
  const [userNameCharErr, setUserNameCharErr] = useState(false);
  const [contactNumberCharErr, setContactNumberCharErr] = useState(false);
  const [isEmailErr, setEmailErr] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [loading, setLoading] = useState(false);
  // const [isSubmitted, setIsSubmitted] = useState(false);
  const [showToaster, setShowToaster] = useState(false);
  const [showCancelToaster, setCancelShowToaster] = useState(false);
  const [disableSubmit, setSubmitDisable] = useState(true);
  const [validated, setValidated] = useState(false);
  const [userName, setUserName] = useState("");
  const [zipCodeStr, setZipCodeStr] = useState("");

  const [userNameError, setUserNameError] = useState("")
  // const closeToaster = () => {setCancelShowToaster(false);}
  const openToaster = () => {
    setCancelShowToaster(true);
  };
  const handleChange = (event) => {
    event.persist();
    if (localStorage.getItem("editUserData")) {
      setIsDataChange(true);
    }
    // if(event.target.name === 'UserName'){
    //   validateUserName(event.target.value);
    // }
    if (
      event.target.name === "ContactNumber" ||
      event.target.name === "ZIPCode" ||
      event.target.name === "FirstName" ||
      event.target.name === "LastName" ||
      event.target.name === "UserName"
    ) {
      restrictFileds(event.target.name, event.target.value);
    } else {
      setValues((values) => ({
        ...values,
        [event.target.name]: event.target.value,
      }));
      if(loggedInUserData !== null && localStorage.getItem("userData")){
        setValues((values) => ({
          ...values,
          CreatedBy: loggedInUserData.UserName,
          ModifiedBy: loggedInUserData.UserName,
          Modifieddate: moment(new Date()).format('MM/DD/YYYY')
        }));
      }
    }
    if(event.target.name === "UserName"){
      setUserNameCharErr(false)
    }
    if(event.target.name === "ContactNumber"){
      setContactNumberCharErr(false)
    }
    let emailValidate = validate(values)
    setErrors(emailValidate);
    // validateForm(values)
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    let errorsData = validate(values)
    setErrors(errorsData);
    if (values.UserName.length < 6) {
      setUserNameCharErr(true)
      return false
    }
    if (values.EmailID.length > 0) {
      const regEx = /^([a-zA-Z0-9._-]+@([a-zA-Z]+\.)+[a-zA-Z]{2,4})?$/
      if (regEx.test(values.EmailID)) {
        setEmailError(false)
      } else {
        setEmailError(true)
        return false
      }
    }
    if (values.ContactNumber.length < 10) {
      setContactNumberCharErr(true)
      return false
    }

    if (loggedInUserData !== null && localStorage.getItem("userData")) {
      setValues((values) => ({
        ...values,
        CreatedBy: loggedInUserData.UserName,
        ModifiedBy: loggedInUserData.UserName,
        Modifieddate: moment(new Date()).format('MM/DD/YYYY')
      }));
    }
    if (localStorage.getItem("editUserData")) {
      if(errorsData.EmailID === undefined && errorsData.ContactNumber === undefined){
        errorsData.EmailID = false;
        errorsData.ContactNumber = false;
      }
      if (
        values.FirstName.length > 0 &&
        values.LastName.length > 0 &&
        values.EmailID.length > 0 &&
        values.RoleID !== '' &&
        values.UserName.length >= 6 &&
        !isEmailErr &&
        !userNameErr &&
        errorsData.EmailID !== undefined && !errorsData.EmailID &&
        errorsData.ContactNumber !== undefined && !errorsData.ContactNumber
        && values.ContactNumber.length === 10 
        // && ((values.ZIPCode == 0 || values.ZIPCode == undefined) || (values.ZIPCode.length > 4))
      ) {
        if(zipCodeStr.length > 0 && zipCodeStr != 0){
          if(zipCodeStr.length < 5){
            errorsData.ZIPCode = "Please check entered Zip Code minimum length should be 5"
            // alert("1")
            setValidated(true)
            return
          }
        }
        setLoading(true);
        let submitData = values;
        if(loggedInUserData !== null && localStorage.getItem("userData")){
          submitData.ModifiedBy = loggedInUserData?.UserName;
        }
        submitData.Modifieddate = moment(new Date()).format('MM/DD/YYYY');
        _HttpServices
          .postData("Api/User/UpdateUser", submitData)
          .then((data) => {
            setErrors({});
            if (data.data || data.data === "") {
              localStorage.removeItem("allUsers");
              setValues(intialValues);
              setErrors({});
              setShowToaster(true);
              setUserUpdated(true);
              setLoading(false);
              localStorage.removeItem("editUserData");
              localStorage.setItem("updated", true);
              history.push("/users");
            }
          })
          .catch((e) => {
            setLoading(false);
          });
      } else {
        // errorsData.ZIPCode = "Minimum length must be 5"
        setValidated(true);
      }
    } else {
      if (
        values.FirstName !== "" &&
        values.LastName !== "" &&
        values.EmailID !== "" &&
        values.RoleID !== "" &&
        !isEmailErr &&
        !userNameErr &&
        !errorsData.EmailID &&
        !errorsData.ContactNumber
        && values.ContactNumber.length === 10
        // && ((values.ZIPCode == 0 || values.ZIPCode == undefined) || (values.ZIPCode !== undefined && values.ZIPCode && values.ZIPCode.length > 4))
      ) {
        if(values.ZIPCode.length > 0 && values.ZIPCode != 0){
          if(values.ZIPCode.length < 5){
            errorsData.ZIPCode = "Please check entered Zip Code minimum length should be 5"
            // alert("2")
            setValidated(true)
            return
          }
        }
        setLoading(true);
        if (values.UserName !== undefined && values.UserName !== "") {
          validateUserName(values.UserName);
        }
        let submitData = values;
        if(loggedInUserData !== null && localStorage.getItem("userData")){
          submitData.CreatedBy = loggedInUserData.UserName;
          submitData.Createddate = moment(new Date()).format('MM/DD/YYYY');
        }
        _HttpServices
          .postData("Api/User/InsertUser", values)
          .then((data) => {
            setLoading(false);
            if (data.data || data.data === "") {
              localStorage.removeItem("allUsers");
              setValues(intialValues);
              setErrors({});
              setShowToaster(true);
              localStorage.setItem("added", true);
              history.push("/users");
            }
          })
          .catch((e) => {
            setLoading(false);
          });
      } else {
        // errorsData.ZIPCode = "Minimum length must be 5"
        setValidated(true);
      }
    }
  };
  useEffect(() => {
    setSubmitDisable(validateForm());
  }, [dispatch, values,userNameErr,isEmailErr,errors]);
  useEffect(() => {
    getUserData();
    getRoles();
    if (localStorage.getItem("userData")) {
      const userData = localStorage.getItem("userData")
      setUserName(JSON.parse(userData).FirstName)
  }
  }, []);
  const validateForm = () => {
    if (
      values.FirstName !== null && values.FirstName.length > 0 &&
      values.LastName !== null && values.LastName.length > 0 &&
      values.UserName !== null && values.UserName.length > 0 &&
      values.ContactNumber !== null && values.ContactNumber.length > 0 &&
      values.EmailID !== null && values.EmailID.length > 0 &&
      values.RoleID !== null && values.RoleID.length > 0 &&
      !isEmailErr &&
      !userNameErr &&
      values.ContactNumber !== null && values.ContactNumber.length > 0
    ) {
      return false;
    } else {
      return true;
    }
  };
  async function getUserData() {
    if (localStorage.getItem("editUserData")) {
      // btnText = "Update";
      setLoading(true);
      await _HttpServices
        .postData(
          `Api/User/EditUser?Id=${
            JSON.parse(localStorage.getItem("editUserData")).Id
          }`,
          {}
        )
        .then((data) => {
          setLoading(false);
          if(data.data.ZIPCode === 0){
            data.data.ZIPCode = ''
          }
          if(data.data.ZIPCode.toString().length === 4){
            data.data.ZIPCode = '0' + data.data.ZIPCode
          }
          setValues(data.data);
          setZipCodeStr(data.data.ZIPCode.toString())
        })
        .catch((e) => {
          setLoading(false);
        });
    } else {
      // btnText = "Submit";
    }
  }
  const restrictFileds = async (name, value) => {
    if (name === "ContactNumber" || name === "ZIPCode") {
      const re = /^[0-9\b]+$/;
      if (value === "" || re.test(value)) {
        setValues((values) => ({
          ...values,
          [name]: value,
        }));
        validateForm(values);
      }
    }
    if (name === "FirstName" || name === "LastName") {
      const re = /^[a-zA-Z \b]+$/;
      if (value === "" || (re.test(value) && value.trim().length > 0)) {
        setValues((values) => ({
          ...values,
          [name]: value,
        }));
        validateForm(values);
      }
    }
    if (name === "UserName") {
      const re = /^[a-zA-Z0-9_]*$/;
        if (value === "" || re.test(value)) {
          setValues((values) => ({
            ...values,
            [name]: value,
          }));
         await validateUserName(value);
      
        }      
    }
  };
  async function getRoles() {
    await _HttpServices
      .getData("Api/User/GetRoles")
      .then((data) => {
        setRoles(data.data);
      })
      .catch((e) => console.log(e));
  }
  const validateUserName = async (value) => {
    const trimmedValue = value.trim();
    if (trimmedValue) {
      _HttpServices
        .getData(`Api/User/ValidateUserName?userName=${trimmedValue}`)
        .then( async (data) => {
          if (data.data !== "") {
            errors.UserName = "";
            if(data.data === "new user"){
              setUserNameError("")
              setUserNameErr(false);
            } else {
              setUserNameErr(true);
              setUserNameError(data.data)
            }
            
          } else {
            await setUserNameErr(false);
          }
          validateForm(value);
        })
        .catch((e) => {
          errors.UserName = ""
          setUserNameError(e.response.data.Message)
          setUserNameErr(true);
          validateForm(value);
        });
    }
  };
  const validateEmail = (event) => {
    if (!localStorage.getItem("editUserData")) {
      const value = event.target.value;
      _HttpServices
        .getData(`Api/User/ValidateEmail?EmailID=${value}`)
        .then((data) => {
          if (data.data !== "") {
            errors.EmailID = "";
            setEmailErr(true);
          } else {
            setEmailErr(false);
          }
        })
        .catch((e) => {
          errors.EmailID = "";
          setEmailErr(true);
        });
    }
  };
  const validateZip = (event) => {
    var charCode = event.which ? event.which : event.keyCode;
    if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57))
      return false;

    return true;
  };
  const redirectUser = () => {
    if (isDataChange) {
      openToaster();
    } else {
      if (!disableSubmit) {
        openToaster();
        // localStorage.removeItem("editUserData");
        // history.push("/users");
      } else {
        localStorage.removeItem("editUserData");
        history.push("/users");
      }
    }
  };
  return (
    <section className="content">
      <div className="page-title">
      {localStorage.getItem("editUserData") &&
        <h2 className="h2">Edit User</h2>
        }
        {!localStorage.getItem("editUserData") &&
        <h2 className="h2">Add User</h2>
        }
      </div>
      {/* Conirm Toaster */}
      <Toast
        onClose={() => setCancelShowToaster(false)}
        show={showCancelToaster}
        style={{
          position: "absolute",
          top: "100px",
          right: 0,
          bottom: 0,
          left: 0,
          margin: "0 auto",
          height: "140px",
          width: "500px",
          zIndex: "99",
        }}
      >
        {/* <Toast.Header>
          <img src="holder.js/20x20?text=%20" className="rounded mr-2" alt="" />
          <strong className="mr-auto">Confirm</strong>
        </Toast.Header> */}
        <Toast.Body>
          <h3 className="h6">Are you sure want to cancel</h3>
          <div className="text-right mt-4">
            <Button
              onClick={() =>
                localStorage.removeItem("editUserData", history.push("/users"))
              }
            >
              <IoMdDoneAll className="icon btn-icon" />
              Yes
            </Button>
            <Button
              variant="danger"
              className="ml-3 btn-sm"
              onClick={() => setCancelShowToaster(false)}
            >
              <IoIosClose className="icon btn-icon" />
              No
            </Button>
          </div>
        </Toast.Body>
      </Toast>
      <div className="card pt-2 pb-3">
        <div className="card-body">
          <Form
            noValidate
            validated={validated}
            onSubmit={(e) => handleSubmit(e)}
          >
            <Row>
              <Col md={6}>
                <Form.Group>
                  <Form.Label htmlFor="FirstName">
                    First Name<span className="required">*</span>
                  </Form.Label>
                  <Form.Control
                    required
                    type="text"
                    name="FirstName"
                    value={values.FirstName}
                    onChange={(e) => handleChange(e)}
                    maxLength={50}
                  />
                  {/* {errors.FirstName ? (
                    <p className="err-msg">{errors.FirstName}</p>
                  ) : null} */}
                  <Form.Control.Feedback type="invalid">
                    Please enter first name.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label htmlFor="LastName">
                    Last Name<span className="required">*</span>
                  </Form.Label>
                  <Form.Control
                    required
                    type="text"
                    name="LastName"
                    value={values.LastName}
                    onChange={(e) => handleChange(e)}
                    maxLength={50}
                  />
                  <Form.Control.Feedback type="invalid">
                    Please enter last name.
                  </Form.Control.Feedback>
                  {/* {errors.LastName ? (
                    <p className="err-msg">{errors.LastName}</p>
                  ) : null} */}
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label htmlFor="UserName">
                    Username<span className="required">*</span>
                  </Form.Label>

                  <Form.Control
                    required
                    type="text"
                    name="UserName"
                    value={values.UserName}
                    onChange={(e) => handleChange(e)}
                    //onInput={(e) => validateUserName(e)}
                    maxLength={50}
                    disabled={localStorage.getItem("editUserData")}
                    className={userNameErr || userNameCharErr ? "is-invalid" : null}
                  />
                  {/* <Form.Text id="UserName" className={userNameCharErr ? "invalid-feedback" : "text-muted"}>
                    Username must contain minimum 6 chartacters.
                  </Form.Text> */}
                  {!userNameErr || userNameCharErr && (
                    <Form.Control.Feedback type="invalid">
                      Please enter username.
                    </Form.Control.Feedback>
                  )}
                  {/* {errors.UserName ? (
                    <p className="err-msg">{errors.UserName}</p>
                  ) : null} */}
                  {userNameErr && (
                    <Form.Control.Feedback type="invalid">
                      {userNameError ? userNameError : "Username alreday exist."}
                    </Form.Control.Feedback>
                  )}
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>
                    Email Id<span className="required">*</span>
                  </Form.Label>
                  <Form.Control
                    required
                    type="email"
                    name="EmailID"
                    value={values.EmailID}
                    disabled={localStorage.getItem("editUserData") && values.RoleID === 2}
                    onChange={(e) => handleChange(e)}
                    // onInput={(e) => validateEmail(e)}
                  />
                  <Form.Control.Feedback type="invalid">
                    Please enter valid email id.
                  </Form.Control.Feedback>
                  {/* {errors.EmailID ? (
                    <p className="err-msg">{errors.EmailID}</p>
                  ) : null} */}
                  {isEmailErr ? (
                    <p className="err-msg">
                      Email already exists, please try with another one.
                    </p>
                  ) : emailError ? (
                    <p className="err-msg">
                      Please enter valid email id.
                    </p>
                  ) : null}
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label htmlFor="ContactNumber">
                    Contact Number<span className="required">*</span>
                  </Form.Label>
                  <Form.Control
                    required
                    type="text"
                    name="ContactNumber"
                    value={values.ContactNumber}
                    onChange={(e) => handleChange(e)}
                    maxLength={10}
                    className={contactNumberCharErr ? "is-invalid" : null}
                    // className={values.ContactNumber !== '' && values.ContactNumber.length < 10 ? "is-invalid" : null}
                  />
                  <Form.Text id="UserName" className={contactNumberCharErr? "invalid-feedback" : "text-muted"}>
                  Contact number must contain 10 numbers.
                </Form.Text>
                  {/* {values.ContactNumber !== '' && values.ContactNumber.length < 10 &&
                  <Form.Control.Feedback type="invalid">
                   Enter valid contact number 
                  </Form.Control.Feedback>
                  } */}
                  {/* {errors.ContactNumber ? (
                    <p className="err-msg">{errors.ContactNumber}</p>
                  ) : null} */}
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Street</Form.Label>
                  <Form.Control
                    type="text"
                    name="Street"
                    value={values.Street}
                    onChange={(e) => handleChange(e)}
                    maxLength={50}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label htmlFor="RoleID">
                    Role<span className="required">*</span>
                  </Form.Label>
                  <Form.Control
                    required
                    as="select"
                    name="RoleID"
                    type="text"
                    value={values.RoleID}
                    onChange={(e) => handleChange(e)}
                  >
                    <option value="" defaultValue disabled>
                      Select Role
                    </option>
                    {roles.length > 0 &&
                      roles.map((role) => (
                        <option key={role.RoleId} value={role.RoleId}>
                          {role.RoleName}
                        </option>
                      ))}
                  </Form.Control>
                  <Form.Control.Feedback type="invalid">
                    Please select role
                  </Form.Control.Feedback>
                  {/* {errors.RoleID ? (
                    <p className="err-msg">Please select role</p>
                  ) : null} */}
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>City</Form.Label>
                  <Form.Control
                    type="text"
                    name="City"
                    value={values.City}
                    onChange={(e) => handleChange(e)}
                    maxLength={20}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Status</Form.Label>
                  <Form.Control
                    as="select"
                    type="text"
                    name="Status"
                    value={values.Status}
                    onChange={handleChange}
                  >
                    <option value="true">Active</option>
                    <option value="false">Inactive</option>
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Zip Code</Form.Label>
                  <Form.Control
                    type="text"
                    name="ZIPCode"
                    value={values.ZIPCode !== 0 ? values.ZIPCode : ''}
                    onKeyPress={(e) => {
                      return validateZip(e);
                    }}
                    onChange={(e) => {
                        handleChange(e);
                        setZipCodeStr(e.target.value.toString())
                      }
                    }
                    maxLength="5"
                  />
                  {errors.ZIPCode ? (
                    <p className="err-msg">{errors.ZIPCode}</p>
                  ) : null}
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={12} className="text-right mt-2">
                {localStorage.getItem("editUserData") && (
                  <Button
                    variant="primary"
                    type="submit"
                    disabled={
                      localStorage.getItem("editUserData") && !isDataChange
                    }
                  >
                    <IoMdDoneAll className="icon btn-icon" />
                    Update
                  </Button>
                )}
                {!localStorage.getItem("editUserData") && (
                  <Button
                    variant="primary"
                    type="submit"
                    disabled={disableSubmit}
                  >
                    <IoMdDoneAll className="icon btn-icon" />
                    Submit
                  </Button>
                )}
                <Button
                  variant="danger"
                  type="button"
                  className="ml-3"
                  onClick={redirectUser}
                >
                  <IoIosClose className="icon btn-icon" />
                  Cancel
                </Button>
              </Col>
              {loading ? <Loader /> : null}
            </Row>
          </Form>
        </div>
      </div>
            
            <Footer />
    </section>
  );
};
// Map Redux state to React component props
const mapStateToProps = (state) => ({
  loading: state.users.loading,
  login: state.users.login,
  users: state.users.users,
  hasErrors: state.users.hasErrors,
});
// Connect Redux to React
export default connect(mapStateToProps)(AddUser);
